import { useFlags } from 'launchdarkly-react-client-sdk';
import { ClientProfileContentItem } from 'store/clientProfile/clientProfileSlice';

import NewNoteView from './newNoteView';
import OldNoteView from './noteView';

const NoteView = ({ note }: { note: ClientProfileContentItem }) => {
  const { enableBillingUpdates } = useFlags();

  if (enableBillingUpdates) {
    return <NewNoteView note={note} />;
  }
  return <OldNoteView note={note} />;
};

export default NoteView;
